import { Routes, Route, Link, useLocation } from 'react-router-dom';


// Main pages
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Services from './pages/Services.jsx';
import Contact from './pages/Contact.jsx';
import BookAppointment from './pages/BookAppointment.jsx';
import Blog from './pages/Blog.jsx';

// Treatment sub-pages
import PediatricDentistry from './pages/Treatments/PediatricDentistry.jsx';
import GumCare from './pages/Treatments/GumCare.jsx';
import Endodontic from './pages/Treatments/Endodontics.jsx';
import LaserDentistry from './pages/Treatments/LaserDentistry.jsx';
import CrownsAndBridges from './pages/Treatments/CrownsBridges.jsx';
import Dentures from './pages/Treatments/Dentures.jsx';
import OralAndMaxillofacialSurgery from './pages/Treatments/OralMaxillofacialSurgery.jsx';
import DentalImplants from './pages/Treatments/DentalImplants.jsx';
import Orthodontics from './pages/Treatments/OrthodonticsBraces.jsx';
import CosmeticDentistry from './pages/Treatments/CosmeticDentistry.jsx';
import Gallery from './pages/Gallery.jsx';
import AboutDrSridhar from './pages/AboutDrSridhar.jsx';
// Layout & shared components
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import WhatsAppFloat from './components/layout/WhatsAppFloat.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import ScrollLink from './components/ScrollLink.jsx'
import BlogPostDetail from './pages/BlogPostDetail';
import FAQ from './pages/faq.jsx'
import CaseStudy from './pages/CaseStudy.jsx';
import DoctorTeam from './pages/DoctorTeam.jsx';
import TakeATour from './pages/TakeATour.jsx';


function App() {
  const location = useLocation();

  return (
    <>
      <Header />

      {/* ✅ MUST be outside Routes */}
      <ScrollToTop />
      <ScrollLink/>

      <Routes location={location} key={location.pathname}>
        {/* Main routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        <Route path="/about-dr-sridhar" element={<AboutDrSridhar />} />

        {/* Treatments */}
        <Route path="/treatments/pediatric-dentistry" element={<PediatricDentistry />} />
        <Route path="/treatments/gum-care" element={<GumCare />} />
        <Route path="/treatments/endodontic" element={<Endodontic />} />
        <Route path="/treatments/laser-dentistry" element={<LaserDentistry />} />
        <Route path="/treatments/crowns-and-bridges" element={<CrownsAndBridges />} />
        <Route path="/treatments/dentures" element={<Dentures />} />
        <Route path="/treatments/oral-maxillofacial-surgery" element={<OralAndMaxillofacialSurgery />} />
        <Route path="/treatments/dental-implants" element={<DentalImplants />} />
        <Route path="/treatments/orthodontics" element={<Orthodontics />} />
        <Route path="/treatments/cosmetic-dentistry" element={<CosmeticDentistry />} />
        <Route path="/blog/:id" element={<BlogPostDetail />} />
              <Route path="/faq" element={<FAQ />} />
                            <Route path="/case-study" element={<CaseStudy />} />
              <Route path="/doctor-team" element={<DoctorTeam />} />
              <Route path="/take-a-tour" element={<TakeATour />} />



        {/* 404 */}
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <div className="text-center">
                <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
                <p className="text-2xl text-gray-700 mb-8">Page Not Found</p>
                <Link
                  to="/"
                  className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition"
                >
                  Back to Home
                </Link>
              </div>
            </div>
          }
        />
      </Routes>


      <Footer />
      <WhatsAppFloat />
    </>
  );
}


export default App;